import type { Feature } from '@luna/gatekeeper';

export const cardUnlock: Feature = {
    enabled: true,
    _description: 'Enables card unlock focus page',
};
